var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"connected-status"},[_c('VIcon',{attrs:{"large":"","color":"red lighten-2"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }